import { Text, Heading } from "../../components";
import ZFLOCFlip from "../../components/ZFLOCFlip";
import React, { Suspense } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Pagination } from 'swiper/modules';
import 'swiper/css/pagination';
import { useMediaQuery } from "react-responsive";

export default function AboutZFlocSection() {
  const cardData = [
    {
      image: '/images/about-1.jpeg',
      heading: 'Our Journey',
      description: 'ZFloc Technologies was born from the collective dreams and aspirations of six friends, united by a shared passion for technology and innovation. Each member brings a unique set of skills and perspectives, creating a dynamic and diverse team capable of tackling the most complex challenges.',
    },
    {
      image: '/images/about-2.jpeg',
      heading: 'Our Mission',
      description: 'We promise to deliver innovative, high-quality software solutions that empower businesses and individuals alike. We strive to stay ahead of the curve, constantly exploring new technologies and methodologies to provide our clients with the best possible outcomes.',
    },
    {
      image: '/images/about-3.jpeg',
      heading: 'Our Vision',
      description: 'At ZFloc, we envision a future where technology is more than just a tool—it’s a force for inspiration, connection, and transformation. We’re not just solving problems; we’re reimagining possibilities. Together, we’re not just building tech—we’re building the future.',
    },
  ];

  const isMobileOrTablet = useMediaQuery({ query: "(max-width: 1250px)" });

  return (
    <>
      {/* About ZFloc section */}
      <div className="relative mb-[106px] md:mb-[20px] sm:mb-[30px] mt-[-750px] sm:mt-[-750px] md:mt-[-700] flex flex-col items-center self-stretch sm:mx-[20px] md:mx-[10px] lg:mx-[150px] xl:mx-[150px]">
        <div className="container-xs flex flex-col gap-20 lg:gap-20 lg:px-5 md:gap-[60px] md:px-5 sm:gap-10">
          <div className="flex flex-col gap-20 lg:gap-20 md:gap-[60px] sm:gap-10">
            <div className="flex flex-col items-center gap-2.5 px-14 md:px-5 sm:px-4 sm:pb-[30px] md:pb-[50px] lg:pb-[50px] xl:pb-[60px] 2xl:pb-[140px]">
              {/* <Heading
                size="headingxl"
                as="h1"
                className="absolute text-[96px] font-semibold uppercase text-center text-gray-950 md:text-[40px] lg:text-[79px] sm:text-[30px] animate-slideUpDown"
              >
                The Essence of ZFloc
              </Heading> */}
              <Heading
                as="p"
                className="absolute text-[96px] font-medium uppercase text-center text-gray-950 md:text-[40px] xl:text-[80px] lg:text-[70px] sm:text-[30px]"
              >
                The Essence of ZFloc
              </Heading>
            </div>
            <Heading
              as="p"
              className="text-center text-[26px] leading-[48px] text-gray-950 xl:text-[28px] lg:text-[27px] md:text-[20px] sm:text-[16px]"
            >
              <div className="font-light">
                Our name, ZFloc, encapsulates who we are and what we stand for.
                The &quot;Z&quot; represents Generation the trailblazers of
                tomorrow, driving change and embracing the future with open
                arms. &quot; Floc&quot; is derived from the word &quot;
                flock,&quot; symbolizing a group moving together towards a
                common goal. <br /> <br className="sm:hidden"/>
                At ZFloc, we believe in the power of teamwork and the strength of
                community.
              </div>
            </Heading>
          </div>

          <div className="flex gap-[30px] lg:gap-[10px] md:flex-col sm:flex-col z-0">
            {isMobileOrTablet ? (
              <Swiper
                spaceBetween={20}
                slidesPerView={1}
                pagination={{ clickable: true }}
                style={{ height: 'auto', width: '100%' }}
                modules={[Pagination]}
              >
                {cardData.map((data, index) => (
                  <SwiperSlide key={"journeyList" + index}>
                    <ZFLOCFlip
                      image={data.image}
                      heading={data.heading}
                      description={data.description}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <Suspense fallback={<div>Loading feed...</div>}>
                {cardData.map((data, index) => (
                  <ZFLOCFlip
                    key={"journeyList" + index}
                    image={data.image}
                    heading={data.heading}
                    description={data.description}
                  />
                ))}
              </Suspense>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
